module.exports = __webpack_public_path__ + "img/34.d0722802.png";